import { render, staticRenderFns } from "./Fields.vue?vue&type=template&id=08501426&scoped=true"
import script from "./Fields.vue?vue&type=script&lang=js"
export * from "./Fields.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  var style0 = require("./Fields.vue?vue&type=style&index=0&id=08501426&prod&lang=scss&scoped=true")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "08501426",
  null
  ,true
)

export default component.exports